import React from "react";
import Footer from "../components/footer/en/Footer";
import Header from "../components/header/en/Header";
import Contents from "../components/pages/pricing/en/Contents";

const Pricing = () => {
    return (
        <div>
        <Header />
        <Contents />
        <Footer />
        </div>
    );
}
export default Pricing;